import styled from "styled-components";

export const Root = styled.main`
  min-height: 100vh;
  color: #fff;
  background-color: #131313;
  font-family: var(--font-nhu);
  font-weight: 200;
  font-size: 1.125rem;
  line-height: 1.75rem;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
`;

export const Masthead = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 0 1.25rem;
  background: url('/watches/hong-kong-dial-ii/background.jpg') no-repeat top left;
  background-size: cover;

  & > * {
    flex: 0 0 auto;
  }
`;

export const LogosWrapper = styled.div`
  width: 100%;

  svg {
    display: block;
    margin: 0 auto;
    width: 100%;
    max-width: 400px;
    height: auto;
  }
`;
